import React, {useMemo, useReducer, useRef} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import DateInput from '../../../components/input/DateInput'
import WizButton from '../../../components/button/WizButton'
import WizImage from '../../../components/image/WizImage'
import {useTime} from '../../../utils/time'
import useNavigation from '../../../hooks/useNavigation'
import WizSelectButton from '../../../components/button/WizSelectButton'
import {createEventApi} from '../../../apis/event/createEventApi'
import ic_check_primary from '../../../assets/images/ic_check_primary.png'
import ic_arrow_right from '../../../assets/images/ic_arrow_right.png'
import img_placeholder from '../../../assets/images/placeholder.png'

interface IProps {
    className?: string
}

const initState = {
    name: '',
    language: localStorage?.getItem('lang') || 'en',
    thumbnail: '',
    new_thumbnail: '',
    url: '',
    start_at: '',
    end_at: '',
    show_on_account_page: false,
    background_color: [],
}

const EventCreatePage: React.FC<IProps> = ({className}) => {
    const {convertInputToTimezone} = useTime()
    const {goEvent} = useNavigation()

    const [state, dispatch] = useReducer(reducer, initState)
    const {name, language, thumbnail, new_thumbnail, url, start_at, end_at, show_on_account_page, background_color} =
        state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const thumbnailRef = useRef<any>()
    const newThumbnailRef = useRef<any>()

    const languageList = useMemo(() => {
        return [
            {id: 'ko', value: 'Korean'},
            {id: 'en', value: 'English'},
        ]
    }, [])

    const onChangeImage = async (e, field) => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({
                type: 'field_update',
                field: field,
                value: result?.image_url,
            })
        }
    }

    const onClickCreateEvent = async () => {
        if (new Date(end_at).getTime() - new Date(start_at).getTime() < 0) {
            alert('시작 시간과 종료 시간을 확인해주세요.')
            return false
        }

        if (language === '') {
            alert('언어를 선택해주세요')
            return false
        }

        const {data} = await createEventApi({
            name: name,
            thumbnail: thumbnail,
            new_thumbnail: new_thumbnail,
            url: url,
            language: language,
            start_at: convertInputToTimezone(start_at) as string,
            end_at: convertInputToTimezone(end_at) as string,
            show_on_account_page: show_on_account_page,
            background_color: background_color,
        })

        if (data?.success) {
            alert('Create Event Complete')
            goEvent()
        }
    }

    return (
        <PageLayout title={'Create Event'}>
            <div
                className={
                    'w-[1000px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[80px] grid grid-cols-2 gap-x-[40px] gap-y-[60px] lg:w-[900px] md:w-[520px] md:px-[40px] sm:w-full sm:block sm:space-y-[30px]'
                }>
                <div className={'col-span-2 w-[50%] mx-auto'}>
                    <div className={'w-full mx-auto md:w-[300px] sm:w-[200px]'}>
                        <Text className={'text-body3 text-font02'}>Event Thumbnail</Text>
                        <div
                            onClick={() => newThumbnailRef?.current?.click()}
                            className={
                                'relative border border-line02 rounded-[5px] overflow-hidden w-full min-h-[196px] max-h-[196px] mt-[10px] cursor-pointer lg:min-h-[139px] sm:min-h-[92px]'
                            }>
                            {new_thumbnail ? (
                                <WizImage
                                    src={`${new_thumbnail?.split('?')?.at(0)}?type=webp&width=1920`}
                                    className={'w-full'}
                                />
                            ) : (
                                <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[50px]">
                                    <WizImage src={img_placeholder} className="w-full h-auto rounded-[5px]" />
                                </div>
                            )}
                        </div>
                        <input
                            type={'file'}
                            onChange={e => onChangeImage(e, 'new_thumbnail')}
                            ref={newThumbnailRef}
                            className={'hidden'}
                        />
                    </div>
                    {/* <div className={'ml-[30px]'}>
                        <Text className={'text-body3 text-font02'}>Background Color</Text>
                        <div className={'mt-[10px]'}>
                            <div
                                style={
                                    background_color?.at(0) && background_color?.at(1)
                                        ? {
                                              backgroundImage: `linear-gradient(to right, ${background_color?.at(
                                                  0,
                                              )}, ${background_color?.at(1)})`,
                                          }
                                        : {
                                              backgroundColor:
                                                  background_color?.at(0) || background_color?.at(1) || '#FFFFFF',
                                          }
                                }
                                className={`border border-line02 rounded-[5px] overflow-hidden w-full min-h-[80px] relative`}></div>
                        </div>
                        <div className={'flex items-center gap-[30px] mt-[20px]'}>
                            <div>
                                <Text className={'text-body3 text-font02'}>Gradation From </Text>
                                <UnderLineInput
                                    value={background_color?.at(0)}
                                    placeholder="#FFFFFF"
                                    onChanged={text => {
                                        const newArr = [background_color?.at(0) || '', background_color?.at(1) || '']
                                        newArr[0] = text
                                        dispatch({
                                            type: 'field_update',
                                            field: 'background_color',
                                            value: newArr,
                                        })
                                    }}
                                />
                            </div>
                            <WizImage src={ic_arrow_right} />
                            <div>
                                <Text className={'text-body3 text-font02'}>Gradation To </Text>
                                <UnderLineInput
                                    value={background_color?.at(1)}
                                    placeholder="#FFFFFF"
                                    onChanged={text => {
                                        const newArr = [background_color?.at(0) || '', background_color?.at(1) || '']
                                        newArr[1] = text
                                        dispatch({
                                            type: 'field_update',
                                            field: 'background_color',
                                            value: newArr,
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>

                <div className={'col-span-2'}>
                    <div
                        onClick={() => {
                            dispatch({
                                type: 'field_update',
                                field: 'show_on_account_page',
                                value: !show_on_account_page,
                            })
                        }}
                        className={'flex items-center gap-x-[5px] justify-center  cursor-pointer '}>
                        <div
                            className={`w-[20px] h-[20px] border rounded-[5px] ${
                                show_on_account_page ? 'border-primary' : 'border-font04'
                            }`}>
                            {show_on_account_page && <WizImage src={ic_check_primary} />}
                        </div>
                        <Text className={'text-body3 text-font02'}>Used Leaderboard Top / Account Page</Text>
                    </div>
                    {show_on_account_page && (
                        <div className={'mx-auto w-[320px] mt-[20px]'}>
                            <Text className={'text-body3 text-font02'}>Banner Thumbnail</Text>
                            <div
                                onClick={() => thumbnailRef?.current?.click()}
                                className={
                                    'relative border border-line02 rounded-[5px] overflow-hidden h-[65px] mt-[10px] cursor-pointer'
                                }>
                                {thumbnail ? (
                                    <WizImage
                                        src={`${thumbnail?.split('?')?.at(0)}?type=webp&width=1920`}
                                        className={'w-full'}
                                    />
                                ) : (
                                    <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-[30px]">
                                        <WizImage src={img_placeholder} className="w-full h-auto rounded-[5px]" />
                                    </div>
                                )}
                            </div>
                            <input
                                type={'file'}
                                onChange={e => onChangeImage(e, 'thumbnail')}
                                ref={thumbnailRef}
                                className={'hidden'}
                            />
                        </div>
                    )}
                </div>

                <div>
                    <Text className={'text-body3 text-font02'}>Title</Text>
                    <UnderLineInput onChanged={text => dispatch({type: 'field_update', field: 'name', value: text})} />
                </div>
                <div>
                    <Text className={'text-body3 text-font02'}>Event Url</Text>
                    <UnderLineInput onChanged={text => dispatch({type: 'field_update', field: 'url', value: text})} />
                </div>

                <div
                    className={
                        'col-span-2 grid grid-cols-3 gap-x-[40px] items-center md:grid-cols-2 md:gap-y-[60px] sm:block sm:space-y-[30px]'
                    }>
                    <div className={'sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>Start At</Text>
                        <DateInput
                            onChange={e => dispatch({type: 'field_update', field: 'start_at', value: e.target.value})}
                            className={'sm:mx-auto'}
                        />
                    </div>
                    <div className={'sm:text-center'}>
                        <Text className={'text-body3 text-font02'}>End At</Text>
                        <DateInput
                            onChange={e => dispatch({type: 'field_update', field: 'end_at', value: e.target.value})}
                            className={'sm:mx-auto'}
                        />
                    </div>
                    <div className={'space-y-[5px] md:col-span-2 md:text-center'}>
                        <Text className={'text-body3 text-font02'}>Channel</Text>
                        <WizSelectButton
                            onChange={e => dispatch({type: 'field_update', field: 'language', value: e.id})}
                            data={languageList}
                            activeValue={languageList?.find(list => list.id === language)}
                            className={'md:mx-auto'}
                        />
                    </div>
                </div>

                <div className={'col-span-2 text-center mt-[30px]'}>
                    <WizButton type={'blue'} size={'big'} text={'Create Event'} onClick={() => onClickCreateEvent()} />
                </div>
            </div>
        </PageLayout>
    )
}

export default EventCreatePage
